import { createEmitter } from 'particle-explosions';
import { RefObject, useEffect } from 'react';

const referenceSize = 500;

const particleOptions = (size: number = referenceSize) => {
    const adjustSize = size / referenceSize;

    return {
        minSize: 5 * adjustSize,
        maxSize: 30 * adjustSize,
        minSpeed: 30 * adjustSize,
        maxSpeed: 80 * adjustSize,
        resistance: 0.9,
        gravity: 1,
        decay: 0.97,
        sizeToRemove: 0.1,
        color: ['#EB5757', '#F2C94C', '#27AE60', '#56CCF2'],
    };
};

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export function useParticles(canvasRef: RefObject<HTMLCanvasElement>, contentRef: RefObject<HTMLElement>) {
    useEffect(() => {
        async function emitParticles() {
            if (canvasRef.current && contentRef.current) {
                const context = canvasRef.current.getContext('2d');
                if (context) {
                    const scale = 3;
                    const padding = 0.25;

                    // Преобразует диапазон [0, 1] в [0 + padding, 1 - padding]
                    const withPadding = (x: number) => (x - 0.5) * (1 - 2 * padding) + 0.5;

                    const w = (canvasRef.current.width = contentRef.current.clientWidth * scale);
                    const h = (canvasRef.current.height = contentRef.current.clientHeight * scale);

                    // Позиционирование по центру
                    const position = `${((1 - scale) / 2) * 100}%`;
                    canvasRef.current.style.top = canvasRef.current.style.left = position;

                    const size = (w + h) / 2 / scale;

                    const emitter = createEmitter(context);
                    const emit = (x: number, y: number) => {
                        emitter.explode(80, {
                            xPos: withPadding(x) * w,
                            yPos: withPadding(y) * h,
                            ...particleOptions(size),
                        });
                    };
                    await delay(150);
                    emit(0.66, 0.75);
                    await delay(100);
                    emit(0.33, 0.25);
                    await delay(100);
                    emit(0.5, 0.5);
                    emit(0.83, 0.23);
                    await delay(100);
                    emit(0.18, 0.72);
                }
            }
        }

        emitParticles().catch(console.error);
    }, [canvasRef, contentRef]);
}
